import { render, staticRenderFns } from "./Addtask.vue?vue&type=template&id=1f20a148&scoped=true"
import script from "./Addtask.vue?vue&type=script&lang=js"
export * from "./Addtask.vue?vue&type=script&lang=js"
import style0 from "./Addtask.vue?vue&type=style&index=0&id=1f20a148&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f20a148",
  null
  
)

export default component.exports